import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';

import { isAdminUser } from 'utils/common';
import { SimpleDropDown, SimpleDropDownElement } from 'components/simple-dropdown';
import { markVideoForDeletionAction } from '../actions';
import { showDialogAction } from 'components/redux-dialog/actions';
import { DELETE_MY_VIDEO_DIALOG } from './delete-my-video-dialog';
import { MarkUnmarkStartHomeVideoDecorated } from 'components/mark-unmark-start-home-video/index';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons';

const Component = ({ video, editVideo, deleteVideo }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <SimpleDropDown
        icon={faEllipsisV}
        className="ct-video-list__context-menu"
        data-e2e="myVideoContextMenu"
        aria-label={t('video-actions-menu')}
      >
        <div data-e2e="editContextMenuItem">
          <SimpleDropDownElement onClick={() => editVideo(video.id)}>
            <FontAwesomeIcon icon={faPencil} /> {t('edit')}
          </SimpleDropDownElement>
        </div>

        <div data-e2e="deleteContextMenuItem">
          <SimpleDropDownElement onClick={() => deleteVideo(video.id)}>
            <FontAwesomeIcon icon={faTrash} /> {t('delete')}
          </SimpleDropDownElement>
        </div>

        {isAdminUser() && (
          <div data-e2e="homeStartVideoMenuItem">
            <MarkUnmarkStartHomeVideoDecorated video={video} />
          </div>
        )}
      </SimpleDropDown>
    </React.Fragment>
  );
};

const ComponentDecorated = compose(
  withRouter,
  connect(null, (dispatch, props) => ({
    editVideo: () => props.history.push(`/my-videos/edit/${props.video.id}`),
    deleteVideo: () => {
      dispatch(markVideoForDeletionAction(props.video.id));
      dispatch(showDialogAction(DELETE_MY_VIDEO_DIALOG));
    },
  }))
)(Component);

export const MyVideosItemMenu = (props) => <ComponentDecorated video={props.video} />;

MyVideosItemMenu.propTypes = {
  video: PropTypes.object.isRequired,
};
